// -------- icons -------- //
import Lamp from 'icons/solid-mono/Lamp';
import Bulb from 'icons/solid-mono/Bulb';
import Puzzle from 'icons/solid-mono/Puzzle';
import Headphone from 'icons/solid-mono/Headphone';

// =========================================================================

// used in the about-2, about-8, about-11, about-13, about-15, about-17 block
export const aboutList1 = [
  ['Aenean quam ornare. Curabitur blandit.', 'Nullam quis risus eget urna mollis ornare.'],
  ['Etiam porta euismod malesuada mollis.', 'Vivamus sagittis lacus vel augue rutrum.']
];

// used in the about-6, about-19 block
export const aboutList2 = [
  ['Aenean eu leo quam ornare curabitur blandit tempus.', 'Nullam quis risus eget urna mollis ornare donec elit.'],
  ['Etiam porta sem malesuada magna mollis euismod.', 'Fermentum massa vivamus faucibus amet euismod.']
];

// used in the about-11, about-19 block
export const aboutList3 = [
  {
    id: 1,
    title: 'Our Vision',
    description: `Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget. Fusce dapibus tellus.`
  },
  {
    id: 2,
    title: 'Our Mission',
    description: `Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet. Sed posuere consectetur.`
  },
  {
    id: 3,
    title: 'Our Values',
    description: `Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna scelerisque.`
  }
];

// used in the about-20, about-21 block
export const aboutList4 = [
  {
    id: 1,
    Icon: Lamp,
    color: 'fuchsia',
    title: 'Creativity',
    description: 'Curabitur blandit lacus porttitor ridiculus mus.'
  },
  {
    id: 2,
    Icon: Bulb,
    color: 'violet',
    title: 'Innovative Thinking',
    description: 'Curabitur blandit lacus porttitor ridiculus mus.'
  },
  {
    id: 3,
    Icon: Puzzle,
    color: 'orange',
    title: 'Rapid Solutions',
    description: 'Curabitur blandit lacus porttitor ridiculus mus.'
  },
  {
    id: 4,
    Icon: Headphone,
    color: 'green',
    title: 'Top-Notch Support',
    description: 'Curabitur blandit lacus porttitor ridiculus mus.'
  }
];
